// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2pNaQ","ranges":"BmiRanges_ranges__2yPR9"};